import axios from "axios";
import * as Sentry from "@sentry/react";
import { waitForAsyncTask } from "./waitForAsyncTask";
const BASE_URL = process.env.REACT_APP_API_URL;

// `document` es uno de los tres de la entrega final (ver utils/finalDocuments) y
// `documentLabel` su nombre para los mensajes; solo aplican a "final-project".
export const uploadProjects = async ({ projectType, subpath, id, projectTitle, selectedFile, url, token, document, documentLabel }) => {
  const projectNameKeyMap = {
    "initial-project": "Anteproyecto",
    "intermediate-project": "Entrega Intermedia",
    "final-project": "Entrega Final",
    "pps-report": "Informe Cumplimiento PPS",
  };

  const errorMessage = documentLabel
    ? `No se pudo completar el envío del documento ${documentLabel}. Por favor, inténtalo de nuevo.`
    : `No se pudo completar el envío de la ${projectNameKeyMap[projectType]}. Por favor, inténtalo de nuevo.`;
  const successMessage = documentLabel
    ? `¡Envío exitoso! Se ha registrado correctamente el documento ${documentLabel}.`
    : `¡Envío exitoso! Se ha registrado correctamente la ${projectNameKeyMap[projectType]}.`;

  try {
    let apiUrl = `${BASE_URL}/${subpath}/${id}/${projectType}?mode=async&project_title=${encodeURIComponent(projectTitle)}`;
    if (document) {
      apiUrl += `&document=${document}`;
    }
    let response;

    // Si es entrega intermedia, enviar la URL
    if (projectType === "intermediate-project") {
      response = await axios.post(
        `${BASE_URL}/${subpath}/${id}/intermediate-report`,
        { url },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201 || response.status === 202) {
        return {
          success: true,
          message: successMessage,
        };
      } else {
        return {
          success: false,
          message: errorMessage,
        };
      }
    } else {
      // Para initial y final projects, se sube un archivo
      const formData = new FormData();
      formData.append("file", selectedFile);
      response = await axios.post(apiUrl, formData, {
        headers: {
          "Content-Type": "application/pdf",
          Authorization: `Bearer ${token}`,
        },
      });

      if ((response.status === 200 || response.status === 201 || response.status === 202) && response.data.task_id && response.data.status === "pending") {
        const result = await waitForAsyncTask(response.data.task_id, token);
        if (result.success) {
          return {
            success: true,
            message: successMessage,
          };
        } else {
          return {
            success: false,
            message: errorMessage,
          };
        }
      } else {
        return {
          success: false,
          message: errorMessage,
        };
      }
    }
  } catch (error) {
    // Un 413 (archivo muy grande) o un 415 (no es un PDF) no se arreglan
    // reintentando, asi que mostrar el errorMessage genérico —que dice
    // justamente "inténtalo de nuevo"— manda al estudiante a un loop. En esos
    // dos casos el backend explica el motivo en `detail`.
    const status = error?.response?.status;
    if (status === 413 || status === 415) {
      const detail = error?.response?.data?.detail;
      return {
        success: false,
        message: detail || "El archivo no es un PDF válido o supera el tamaño máximo.",
      };
    }

    Sentry.captureException(error);
    console.error(`Error al enviar la ${projectNameKeyMap[projectType]}`, error);
    return {
      success: false,
      message: errorMessage,
    };
  }
};
